import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, getDoc, addDoc, serverTimestamp } from "firebase/firestore";
import { db, auth  } from "../firebase";
import { useNavigate } from "react-router-dom";
import "../Styles/SelectHub.css";
import GetUserData from "../Hooks/GetUserData";

const SelectHub = () => {
  const [hubs, setHubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedHub, setSelectedHub] = useState("");
  const navigate = useNavigate();
  const { userData, loadingB } = GetUserData();

  const isSuperAdmin = !loadingB && userData?.hubId?.includes("__superadmin__");

  useEffect(() => {
    async function fetchUserHubs() {
      try {
        const authUser = (await import("firebase/auth")).getAuth().currentUser;
        if (!authUser) {
          navigate("/login");
          return;
        }

        // 🔹 Esperar hasta que userData esté cargado
        if (loadingB) return;

        const userHubs = userData?.hubId || [];

        if (!Array.isArray(userHubs)) {
          console.error("El campo hubId no es un array");
          return;
        }

        let hubsList = [];

        if (isSuperAdmin) {
          // Superadmin puede ver todos los hubs
          const hubsSnapshot = await getDocs(collection(db, "private-hubs"));
          hubsList = hubsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        } else {
          // Eliminar IDs reservados antes de buscarlos
          const validHubIds = userHubs.filter(id => !id.startsWith("__"));
          const hubDocs = await Promise.all(
            validHubIds.map(id => getDoc(doc(db, "private-hubs", id)))
          );
          hubsList = hubDocs
            .filter(doc => doc.exists())
            .map(doc => ({ id: doc.id, ...doc.data() }));
        }

        setHubs(hubsList);

        // Si solo hay un hub, redirigir automáticamente
        if (hubsList.length === 1) {
          navigate(`/lobby/${hubsList[0].id}`);
        }
      } catch (error) {
        console.error("Error cargando hubs:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchUserHubs();
  }, [navigate, userData, loadingB, isSuperAdmin]);

  const handleNavigate = async () => {
    if (selectedHub) {
      const user = auth.currentUser;
      await addDoc(
          collection(db, `private-hubs/${selectedHub}/Accesos`),
          {
            uid: user.uid,
            email: user.email,
            timestamp: serverTimestamp(),
          }
        );
        navigate(`/lobby/${selectedHub}`);
    }
  };

  if (loading || loadingB) {
    return <p>Cargando hubs...</p>;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f0f4f8",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          width: "100%",
          maxWidth: "350px",
        }}
      >
        <h2 className="select-hub-title">Seleccione un Private Hub</h2>

        {hubs.length === 0 ? (
          <p>No tienes acceso a ningún hub.</p>
        ) : (
          <>
            <select
              value={selectedHub}
              onChange={(e) => setSelectedHub(e.target.value)}
              className="company-selector"
            >
              <option value="">-- Seleccione un hub --</option>
              {hubs.map((hub) => (
                <option key={hub.id} value={hub.id}>
                  {hub.NombrePrivado || hub.id}
                </option>
              ))}
            </select>

            <button
              onClick={handleNavigate}
              disabled={!selectedHub}
              className="footer-button"
            >
              Entrar al Hub
            </button>

            {isSuperAdmin && (
              <button
                onClick={() => navigate(`/create-hub`)}
                className="footer-button"
              >
                Crear nuevo Hub
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SelectHub;
